const languageType = {
  zh: {
    code: 'zh',
    displayName: '中文'
  },
  en: {
    code: 'en',
    displayName: 'English'
  }
}

export default languageType
